import React from 'react';

const MenuIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24">
    <path d="M15.3 3.3l1.4 1.4L9.4 12l7.3 7.3-1.4 1.4L6.6 12z" />
  </svg>
);

export default MenuIcon;
